import { useLocalization } from "@progress/kendo-react-intl";
import axios from "axios";
import { useEffect, useState } from "react";
import { AccessToken } from "../../config/AccessToken";
import { SvgIcon } from "@progress/kendo-react-common";
import { checkIcon, xCircleIcon } from "@progress/kendo-svg-icons";



export const HealthChecker = () => {

    const healthCheckerTimeDifference= 5;

    const [error, setError] = useState('');

    const [healthStatus, setHealthStatus] = useState([]);

    const localizationService = useLocalization();

    const [instance, accessTokenRequest] = AccessToken();


    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        let languageId = localStorage.getItem('languageId');

        const commonOperations = async (accessToken: any) => {
            const headers = { 
                'Authorization': `Bearer ${accessToken}`, 
                'Language': languageId,
                //'Content-Security-Policy': 'upgrade-insecure-requests'  
            };
            
            try {
                const res = await axios.get("http://54.217.164.88:5001/api/KeepAlive", { headers })
                const data = res.data.data

                setHealthStatus(data);                
                
            }catch (error: any) {
                setError(error);
            }
        }
        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const isServiceOK = (lastKeepAlive:any) => {
        const currentTime:any = new Date();
        const lastKeepAliveTime:any = new Date(lastKeepAlive);
        const timeDifference:any = (currentTime - lastKeepAliveTime) / (1000 * 60); // Difference in minutes
    
        return timeDifference <= healthCheckerTimeDifference;
    };

    return (
        <div>
            <ul>
                {healthStatus?.map(( application:any, lastKeepAlive:any ) => (
                    <li className='list-service' key={application}>
                    <div className='service-info' style={{ display: 'flex', alignItems: 'center' }}>
                        {isServiceOK(lastKeepAlive) ? 
                            <SvgIcon icon={checkIcon} color="green" style={{ fontSize: '24px' }} />                         
                        : 
                            <SvgIcon icon={xCircleIcon} color="red" style={{ fontSize: '24px' }} />
                        }
                        <span style={{ fontSize: '14px', marginLeft:'15px' }}>{application}</span>
                    </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}